import { z } from 'zod'

const env = z.object({
    VITE_APP_I18N_LOCALE: z.enum([ 'he', 'en' ]),
    VITE_APP_I18N_FALLBACK_LOCALE: z.enum([ 'he', 'en' ]),
    VITE_APP_FALLBACK_URL: z.string().url(),
    VITE_APP_API_URL: z.string().url(),
    VITE_APP_EVENTS_SDK_SETTINGS_URL: z.string().url(),
    VITE_APP_EVENTS_SDK_LOGIN_URL: z.string().url(),
    VITE_APP_EVENTS_SDK_REFRESH_TOKEN_URL: z.string().url(),
    VITE_APP_EVENTS_SERVER_FETCH_STRATEGY: z.string(),
    VITE_APP_LOGGER_API_URL: z.string().url(),
    VITE_APP_BRANDING_SECTION_NAME: z.string(),
    VITE_APP_REQUEST_DOMAIN: z.string(),
    VITE_APP_CDR_INFO_URL: z.string().url(),
    VITE_APP_CDR_SEARCH_URL_TEMPLATE: z.string().optional(),
    VITE_APP_DEFAULT_DOMAIN_NAME: z.string().optional(),
    VITE_APP_EVENTS_SDK_SERVERS: z.string().optional(),
    VITE_APP_EVENTS_SDK_OPTIONS: z.string().optional(),
    VITE_LOGGED_SECTIONS: z.preprocess(
        (val) => {
            if (typeof val === 'string' && val.trim() !== '') {
                return val.split(',').map((section) => section.trim())
            } else {
                return []
            }
        },
        z.array(z.string())
    ),
})

export default env.parse(import.meta.env)
